// Entry for dist/js/verify.js (+ verify.css), loaded on the app pages (afterhourz.tv
// and studio.afterhourz.tv). Mounts <AgeVerificationModal /> in its own root,
// outside the app bundle, using the shared Supabase client from js/auth.js.

import { render } from 'preact';
import { AgeVerificationModal } from './AgeVerificationModal';
import './verify.css';

function mount() {
  const auth = window.AHAuth;
  const supabase = auth?.getSupabase();
  if (!supabase) return; // static preview without Supabase: nothing to verify
  const root = document.createElement('div');
  root.id = 'ah-verify-root';
  document.body.appendChild(root);
  render(<AgeVerificationModal supabase={supabase} signOut={auth.signOut} />, root);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
else mount();
